module.exports = "/_next/static/images/Hero@3x-a19f5ced1ed796720b5d56b4e4e1375f.webp";